(() => {
  const config = window.AryMixConfig;
  if (!config?.handle) return;

  const escapeSelector = value => (window.CSS?.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, "\\$&"));

  function findOptionControl(root, optionName) {
    const expected = String(optionName).toLowerCase();
    const candidates = [...root.querySelectorAll('[data-option-name], select[name*="options"], input[name*="options"]')];
    const input = candidates.find(element => {
      const name = element.dataset?.optionName || element.getAttribute('name') || '';
      return name.toLowerCase().includes(expected);
    });
    return input?.closest('fieldset, .variant-option, .product-form__input, .product-form__controls') || input?.parentElement || null;
  }

  function nativeFlavorInputs(form, flavorName) {
    const key = String(flavorName).toLowerCase();
    return [...form.querySelectorAll('input, select')].filter(element => {
      const option = element.dataset?.optionName || element.getAttribute('name') || '';
      return option.toLowerCase().includes(key);
    });
  }

  async function init() {
    if (document.querySelector('[data-ary-mix-picker]')) return;

    const form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;

    let product;
    try {
      const response = await fetch('/products/' + encodeURIComponent(config.handle) + '.js');
      product = await response.json();
    } catch (error) {
      return;
    }

    const flavorIndex = product.options.findIndex(name => /^(flavor|flavour|candies|candy)$/i.test(name));
    if (flavorIndex < 0) return;
    const flavorName = product.options[flavorIndex];
    const flavors = product.options_with_values?.[flavorIndex]?.values || [];
    if (!flavors.length) return;

    const flavorControl = findOptionControl(form, flavorName) || findOptionControl(document, flavorName);
    if (flavorControl) {
      flavorControl.classList.add('ary-mix-native-flavor');
      flavorControl.setAttribute('aria-hidden', 'true');
    }

    const panel = document.createElement('section');
    panel.className = 'ary-mix-picker';
    panel.dataset.aryMixPicker = 'true';
    panel.innerHTML = '<div class="ary-mix-picker__heading">Pick your flavors</div><p class="ary-mix-picker__note">Choose 1 to 5 flavors/candies for this bag.</p><div class="ary-mix-picker__choices"></div><p class="ary-mix-picker__message" aria-live="polite"></p>';

    const choices = panel.querySelector('.ary-mix-picker__choices');
    const message = panel.querySelector('.ary-mix-picker__message');
    const property = document.createElement('input');
    property.type = 'hidden';
    property.name = 'properties[Selected Mix]';
    property.className = 'ary-mix-property';
    form.append(property);

    const syncNativeFlavor = value => {
      const inputs = nativeFlavorInputs(form, flavorName);
      const radio = inputs.find(input => input.type === 'radio' && input.value === value);
      const select = inputs.find(input => input.tagName === 'SELECT');
      if (radio && !radio.checked) radio.click();
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const update = () => {
      const checked = [...panel.querySelectorAll('input:checked')].map(input => input.value);
      property.value = checked.join(', ');
      message.textContent = checked.length ? checked.length + ' flavor' + (checked.length === 1 ? '' : 's') + ' selected' : '';
      panel.querySelectorAll('input:not(:checked)').forEach(input => { input.disabled = checked.length >= 5; });
      if (checked[0]) syncNativeFlavor(checked[0]);
      return checked;
    };

    flavors.forEach(flavor => {
      const label = document.createElement('label');
      label.className = 'ary-mix-picker__choice';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = flavor;
      input.addEventListener('change', update);
      const text = document.createElement('span');
      text.textContent = flavor;
      label.append(input, text);
      choices.append(label);
    });

    if (flavorControl?.parentNode) flavorControl.parentNode.insertBefore(panel, flavorControl);
    else form.prepend(panel);

    const requireSelection = event => {
      if (event.defaultPrevented) return;
      if (!panel.querySelector('input:checked')) {
        event.preventDefault();
        message.textContent = 'Please choose at least one flavor/candy.';
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    form.addEventListener('submit', requireSelection, true);
    form.querySelectorAll('button[type="submit"], .add-to-cart-button').forEach(button => {
      button.addEventListener('click', requireSelection, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();